import Moment, { MomentProps } from "react-moment";
import { Constants } from "../../../constants";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import NoDataIndicator from "../NoDataIndicator/NoDataIndicator";

type DateTimeProps = {
  showTime?: boolean;
} & Omit<MomentProps, "format">;

const DateTime = ({
  showTime = false,
  className,
  children,
}: PropsWithClassName<DateTimeProps>) => {
  const format = showTime ? Constants.DATE_TIME_FORMAT : Constants.DATE_FORMAT;
  return children ? (
    <Moment format={format} className={className ?? ""}>
      {children}
    </Moment>
  ) : (
    <NoDataIndicator />
  );
};

export default DateTime;
